import React from 'react';
import { PaperContent, ButtonWithLoader, RFFormCheckbox } from 'virtues-bootstrap';

import { Field, reduxForm } from 'redux-form';
import { compose } from 'ramda';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { FORM_NAMES } from 'constants/forms';

import s from './styles.module.scss';

const NotificationSettings = ({ isEmail, handleSubmit, t, pristine, submitting }) => (
  <PaperContent>
    <form onSubmit={handleSubmit}>
      <p>{t('notificationSettings.info')}</p>
      <div className={s.checkboxWrapper}>
        <Field
          disabled={!isEmail}
          component={RFFormCheckbox}
          name="allowEmail"
          label={t('notificationSettings.allowEmail')}
        />
      </div>
      <div className={s.footer}>
        {!isEmail && <p>{t('notificationSettings.noEmailMsg')}</p>}
        <ButtonWithLoader disabled={!isEmail || pristine} loading={submitting} type="submit">
          {t('buttons.saveSettings')}
        </ButtonWithLoader>
      </div>
    </form>
  </PaperContent>
);

NotificationSettings.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  isEmail: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default compose(
  reduxForm({
    form: FORM_NAMES.notificationsSetting,
  }),
  withTranslation(),
)(NotificationSettings);
